import { c as _c } from "react/compiler-runtime";
import { DrawerSelect } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { statusOptions, type StatusSelectProps } from './status-select';
function StatusSelectDrawer(t0) {
  const $ = _c(5);
  const {
    statuses,
    setStatuses
  } = t0;
  let t1;
  if ($[0] !== setStatuses) {
    t1 = values => {
      setStatuses(values as Parameters<StatusSelectProps['setStatuses']>[0]);
    };
    $[0] = setStatuses;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== handleChange || $[3] !== statuses) {
    t2 = <DrawerSelect value={statuses} onChange={handleChange} label="Statuses" options={statusOptions} multiselect={true} enableSelectAll={true} selectAllLabel="Select All" />;
    $[2] = handleChange;
    $[3] = statuses;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { StatusSelectDrawer };